import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { IoMdHelpCircle } from "react-icons/io";
import styled from "styled-components";
import { Orientation, PopupSubMenu, PopupSubMenuIconContainer } from "../menu/PopupSubMenu";
import { Heading1Base } from "../shared/Heading";
const Heading = styled(Heading1Base).withConfig({
  displayName: "TextFormatInfoPopup__Heading",
  componentId: "sc-1p9rulf-0"
})(["padding-top:0.3em;padding-bottom:0.3em;"]);
const SpacingRow = styled.tr.withConfig({
  displayName: "TextFormatInfoPopup__SpacingRow",
  componentId: "sc-1p9rulf-1"
})(["height:0.7em;"]);
const LabelExamplePairContainer = styled.tr.withConfig({
  displayName: "TextFormatInfoPopup__LabelExamplePairContainer",
  componentId: "sc-1p9rulf-2"
})([""]);
const SpacingAfterLabelExamplePair = styled.tr.withConfig({
  displayName: "TextFormatInfoPopup__SpacingAfterLabelExamplePair",
  componentId: "sc-1p9rulf-3"
})(["height:0.5em;"]);
const Label = styled.th.withConfig({
  displayName: "TextFormatInfoPopup__Label",
  componentId: "sc-1p9rulf-4"
})(["font-weight:normal;text-align:right;padding-right:1em;"]);
const Example = styled.td.withConfig({
  displayName: "TextFormatInfoPopup__Example",
  componentId: "sc-1p9rulf-5"
})([""]);
const Keyword = styled.span.withConfig({
  displayName: "TextFormatInfoPopup__Keyword",
  componentId: "sc-1p9rulf-6"
})(["background:lightgrey;"]);
const KeywordBold = styled(Keyword).withConfig({
  displayName: "TextFormatInfoPopup__KeywordBold",
  componentId: "sc-1p9rulf-7"
})(["font-weight:bold;"]);
const KeywordItalic = styled(Keyword).withConfig({
  displayName: "TextFormatInfoPopup__KeywordItalic",
  componentId: "sc-1p9rulf-8"
})(["font-style:italic;"]);

const LabelExamplePair = ({
  labelKey,
  exampleKey,
  exampleElement = /*#__PURE__*/React.createElement(Keyword, null)
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LabelExamplePairContainer, null, /*#__PURE__*/React.createElement(Label, null, t(labelKey)), /*#__PURE__*/React.createElement(Example, null, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: exampleKey
  }, exampleElement))), /*#__PURE__*/React.createElement(SpacingAfterLabelExamplePair, null));
};

export const TextFormatInfoPopup = ({
  showTextStyleOptions
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(PopupSubMenu, {
    orientation: Orientation.Left,
    relativeOffset: 0,
    buttonContent: /*#__PURE__*/React.createElement(PopupSubMenuIconContainer, null, /*#__PURE__*/React.createElement(IoMdHelpCircle, null)),
    containerWidth: "max-content",
    positionFixed: true
  }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, showTextStyleOptions && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2
  }, /*#__PURE__*/React.createElement(Heading, null, t("action_editor.text_formatting_style_headline")))), /*#__PURE__*/React.createElement(LabelExamplePair, {
    labelKey:
    /*t*/
    "action_editor.text_formatting_style_bold",
    exampleKey:
    /*t*/
    "action_editor.text_formatting_style_emphasis_example",
    exampleElement: /*#__PURE__*/React.createElement(KeywordBold, null)
  }), /*#__PURE__*/React.createElement(LabelExamplePair, {
    labelKey:
    /*t*/
    "action_editor.text_formatting_style_italic",
    exampleKey:
    /*t*/
    "action_editor.text_formatting_style_italic_example",
    exampleElement: /*#__PURE__*/React.createElement(KeywordItalic, null)
  }), /*#__PURE__*/React.createElement(SpacingRow, null)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: 2
  }, /*#__PURE__*/React.createElement(Heading, null, t("action_editor.text_formatting_embedding")))), /*#__PURE__*/React.createElement(LabelExamplePair, {
    labelKey:
    /*t*/
    "action_editor.text_formatting_embedding_action_tree_parameter",
    exampleKey:
    /*t*/
    "action_editor.text_formatting_embedding_action_tree_parameter_example"
  }), /*#__PURE__*/React.createElement(LabelExamplePair, {
    labelKey:
    /*t*/
    "action_editor.text_formatting_embedding_variable",
    exampleKey:
    /*t*/
    "action_editor.text_formatting_embedding_variable_example"
  }), /*#__PURE__*/React.createElement(LabelExamplePair, {
    labelKey:
    /*t*/
    "action_editor.text_formatting_embedding_item_name",
    exampleKey:
    /*t*/
    "action_editor.text_formatting_embedding_item_name_example"
  }), /*#__PURE__*/React.createElement(LabelExamplePair, {
    labelKey:
    /*t*/
    "action_editor.text_formatting_embedding_character_name",
    exampleKey:
    /*t*/
    "action_editor.text_formatting_embedding_character_name_example"
  }), /*#__PURE__*/React.createElement(LabelExamplePair, {
    labelKey:
    /*t*/
    "action_editor.text_formatting_embedding_player_name",
    exampleKey:
    /*t*/
    "action_editor.text_formatting_embedding_player_name_example"
  }))));
};